import { buildSubtitle, buildExecutionSubtitle } from "../utils";

export const buildGitlabSubtitle = buildSubtitle;
export const buildGitlabExecutionSubtitle = buildExecutionSubtitle;
